import { render, staticRenderFns } from "./orderOperation.vue?vue&type=template&id=3581d362&scoped=true"
import script from "./orderOperation.vue?vue&type=script&lang=js"
export * from "./orderOperation.vue?vue&type=script&lang=js"
import style0 from "./orderOperation.vue?vue&type=style&index=0&id=3581d362&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581d362",
  null
  
)

export default component.exports